import React from 'react';
import { Download, Trash2, File } from 'lucide-react';

const FileAttachmentList = ({ files, kind, onDownload, onDelete, isLoading }) => {
  if (!files || files.length === 0) {
    return <p className="text-sm text-gray-500 italic">Nenhum arquivo anexado</p>;
  }

  const kindLabel = kind === 'application_map' ? 'Mapa de Aplicação' : 'Receituário Agronômico';

  return (
    <div className="space-y-2 mt-2">
      <div className="text-xs text-gray-600 font-medium">
        {files.length} arquivo{files.length !== 1 ? 's' : ''} anexado{files.length !== 1 ? 's' : ''}
      </div>
      {files.map((file, index) => (
        <FileItem
          key={`${kind}-${index}`}
          file={file}
          index={index}
          kind={kind}
          kindLabel={kindLabel}
          onDownload={onDownload}
          onDelete={onDelete}
          isLoading={isLoading}
        />
      ))}
    </div>
  );
};

const FileItem = ({ file, index, kind, kindLabel, onDownload, onDelete, isLoading }) => {
  const fileName = typeof file === 'string' ? file : file?.name || `Arquivo ${index + 1}`;

  return (
    <div className="flex items-center justify-between bg-gray-50 rounded-lg p-3 border border-gray-200">
      <div className="flex items-center space-x-3 flex-1 min-w-0">
        <File className="h-5 w-5 text-gray-400 flex-shrink-0" />
        <span className="text-sm text-gray-700 truncate" title={fileName}>
          {fileName}
        </span>
      </div>
      <div className="flex items-center space-x-2 flex-shrink-0">
        <button
          type="button"
          onClick={() => onDownload(kind, index)}
          disabled={isLoading}
          className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors disabled:opacity-50"
          title={`Baixar ${kindLabel}`}
        >
          <Download className="h-4 w-4" />
        </button>
        <button
          type="button"
          onClick={() => onDelete(kind, index)}
          disabled={isLoading}
          className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors disabled:opacity-50"
          title={`Excluir ${kindLabel}`}
        >
          <Trash2 className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default FileAttachmentList;
